<template>
  <svg
    class="mark"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <!--
      A rift aperture: two chevrons that would close into a diamond but are
      held apart on the horizontal axis, with the core between them.

      It replaces a 32px rounded rectangle containing the letters "DX" set in
      Orbitron — a placeholder mark that read as a favicon someone had not got
      round to, and which repeated the wordmark sitting directly beside it.

      Drawn on a 24 grid with round joins so it stays legible at the 26px it
      actually renders at, and it inherits `currentColor` so the header sets
      the colour in one place.
    -->
    <path
      d="M3.5 12.7 L12 4.2 L20.5 12.7"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.5 11.3 L12 19.8 L20.5 11.3"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
      opacity="0.55"
    />
    <path d="M12 9.6 L14.4 12 L12 14.4 L9.6 12 Z" fill="currentColor" />
  </svg>
</template>

<style scoped>
.mark {
  display: block;
  overflow: visible;
}
</style>
